/**
 * Slick slider
 */

(function($) {

  $('.testimonial-slider__wrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: false,
    slide: 'div',
    infinite: false,
  });

})(jQuery);
